


























































import Vue, { PropType } from 'vue';
import { IBusinessSummary } from '@/Store';
import AutoBlurTextField from '@/components/AutoBlurTextField.vue';

export default Vue.extend({
  name: 'BaseMallOverviewDirectory',
  props: {
    businesses: {
      type: Array as PropType<IBusinessSummary[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
    };
  },
  components: {
    AutoBlurTextField,
  },
});
